export const getFontSizeNumber = (fontSizeString: string) => {
  return parseInt(fontSizeString.replace(/\D/g, ''), 10);
};
